import { jsx as _jsx } from "react/jsx-runtime";
import './Typography.css';
const Typography = ({ className = '', children, fontSize = '', fontFamily = '', fontWeight = '', fontStyle, color = '', rtl = false, textTransform, alignLeft = 'left', alignRight = 'right', height, width, onClick }) => {
    const textAlign = rtl ? alignRight : alignLeft;
    return (_jsx("div", Object.assign({ className: `typography ${className}`, onClick: onClick, style: {
            fontSize,
            fontFamily,
            fontWeight,
            fontStyle,
            color,
            textAlign,
            textTransform,
            height,
            width
        } }, { children: children }), void 0));
};
export default Typography;
